/* ============================================
   QUOTE WORKSTATION — Actions
   Asset: workstation-actions.js
   Fee dropdown options, request button + submit,
   quote age counter, bulk actions modal
   ============================================ */
(function() {
  'use strict';
  var Q = window.QWS;
  if (!Q) return;
  var state = Q.state;
  var dom = Q.dom;
  var wrap = Q.wrap;
  var isAdmin = Q.isAdmin;
  var fmt = Q.fmt;
  var parseMoney = Q.parseMoney;
  var escHtml = Q.escHtml;
  var escAttr = Q.escAttr;
  var showToast = Q.showToast;
  var calculateDirect = Q.calculateDirect;
  var reversePoints = Q.reversePoints;

  /* Adapt fee dropdown options based on role and freight/install status */
  function updateFeeDropdownOptions() {
    var shipSel = wrap.querySelector('.rq-ws-fees__status[data-fee="shipping"]');
    var instSel = wrap.querySelector('.rq-ws-fees__status[data-fee="installation"]');
    if (shipSel) rebuildFeeOptions(shipSel, 'shipping', state.freight);
    if (instSel) rebuildFeeOptions(instSel, 'installation', state.installation);
    updateRequestButton();
  }

  function rebuildFeeOptions(sel, feeKey, logisticsState) {
    var currentVal = sel.value;
    var status = logisticsState.status;
    var opts = [];

    if (isAdmin) {
      opts.push({ value: 'pending', label: 'Pending' });
      opts.push({ value: 'value', label: '$' });
      if (status === 'requested') opts.push({ value: 'requested', label: 'Requested ✓' });
      if (status === 'quoted' || status === 'partially_quoted') {
        var amt = feeKey === 'shipping' ? state.freight.totalQuoted : state.installation.totalQuoted;
        var label = status === 'partially_quoted' ? 'Partial: ' + fmt(amt) : 'Quoted: ' + fmt(amt);
        opts.push({ value: 'quoted', label: label });
      }
      opts.push({ value: 'free', label: 'FREE' });
      if (feeKey === 'shipping') opts.push({ value: 'pickup', label: 'Will Call' });
      opts.push({ value: 'none', label: 'None' });
    } else {
      var feeIdx2 = feeKey === 'shipping' ? 0 : 1;
      var repFeeStatus = state.fees[feeIdx2] ? state.fees[feeIdx2].status : null;
      opts.push({ value: 'pending', label: 'Pending' });
      if (repFeeStatus === 'value') {
        opts.push({ value: 'value', label: '$' });
      }
      if (status === 'quoted' || status === 'partially_quoted') {
        var amt2 = feeKey === 'shipping' ? state.freight.totalQuoted : state.installation.totalQuoted;
        var label2 = status === 'partially_quoted' ? 'Partial: ' + fmt(amt2) : 'Quoted: ' + fmt(amt2);
        opts.push({ value: 'quoted', label: label2 });
      }
      opts.push({ value: 'free', label: 'FREE' });
      /* CUSTOM_WILLCALL_BY_CLAUDE (Ryan 2026-09-17) — SHIPPING ONLY, and offered to reps as well
         as admins: a rep taking the order is the one who hears "we'll come and get it". There is
         no such thing as a customer collecting an INSTALLATION, and an option that cannot mean
         anything on the row it sits on is one somebody eventually picks. */
      if (feeKey === 'shipping') opts.push({ value: 'pickup', label: 'Will Call' });
      opts.push({ value: 'none', label: 'None' });
    }

    sel.innerHTML = '';
    opts.forEach(function(o) {
      var opt = document.createElement('option');
      opt.value = o.value;
      opt.textContent = o.label;
      sel.appendChild(opt);
    });

    var feeIdx = feeKey === 'shipping' ? 0 : 1;
    var feeStatus = state.fees[feeIdx] ? state.fees[feeIdx].status : null;
    if (feeStatus === 'value') {
      sel.value = 'value';
    } else if (feeStatus === 'free') {
      sel.value = 'free';
    /* CUSTOM_WILLCALL_BY_CLAUDE (Ryan 2026-09-17) — ⛔ THE OPTION LIST IS NOT THE ONLY LADDER.
       Adding "Customer Pick-Up" to `opts` above put it in the dropdown and left it unselectable:
       this ladder maps the SAVED status back onto the control, and a status it does not name falls
       through to the final `else` and is repainted as **Pending**. Since `updateFeeDropdownOptions`
       runs after every fee change and on every quote load, picking it looked like nothing happened
       at all — and a saved pick-up was silently lost the next time the quote was opened.
       ⛔ IT MUST SIT WITH free / none, ABOVE the `status === 'quoted'` branch: those read the
       freight PANEL's lifecycle, and a deal whose freight was quoted earlier would otherwise
       repaint as "Quoted: $x" over a row the customer is collecting. */
    } else if (feeStatus === 'pickup') {
      sel.value = 'pickup';
    } else if (feeStatus === 'none') {
      sel.value = 'none';
    } else if (status === 'quoted' || status === 'partially_quoted') {
      sel.value = 'quoted';
    } else if (status === 'requested') {
      sel.value = isAdmin ? 'requested' : 'pending';
    } else {
      sel.value = 'pending';
    }

    var input = wrap.querySelector('.rq-ws-fees__input[data-fee="' + feeKey + '"]');
    if (input) {
      input.style.display = (sel.value === 'value') ? '' : 'none';
      if (sel.value === 'quoted') {
        var qAmt = feeKey === 'shipping' ? state.freight.totalQuoted : state.installation.totalQuoted;
        input.value = fmt(qAmt);
        input.style.display = '';
        input.readOnly = !isAdmin;
        input.style.opacity = isAdmin ? '' : '0.6';
      } else if (sel.value !== 'value') {
        input.readOnly = false;
        input.style.opacity = '';
      }
    }

    var csWrap = wrap.querySelector('.rq-ws-custom-select[data-fee="' + feeKey + '"]');
    if (csWrap && csWrap._btn) {
      var csDrop = csWrap.querySelector('.rq-ws-custom-select__drop');
      if (csDrop) {
        csDrop.innerHTML = '';
        for (var oi = 0; oi < sel.options.length; oi++) {
          var optBtn = document.createElement('button');
          optBtn.type = 'button';
          optBtn.className = 'rq-ws-custom-select__opt';
          optBtn.setAttribute('data-value', sel.options[oi].value);
          optBtn.textContent = sel.options[oi].textContent;
          csDrop.appendChild(optBtn);
        }
      }
      var selIdx = sel.selectedIndex;
      csWrap._btn.textContent = (selIdx >= 0 && sel.options[selIdx]) ? sel.options[selIdx].textContent : '';
    }
  }

  /* Override fee status change handler for freight/install state sync */
  wrap.querySelectorAll('.rq-ws-fees__status').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var feeKey = this.getAttribute('data-fee');
      if (feeKey !== 'shipping' && feeKey !== 'installation') return;
      var idx = feeKey === 'shipping' ? 0 : 1;
      var logistics = feeKey === 'shipping' ? state.freight : state.installation;
      var val = this.value;

      if (val === 'free') {
        state.fees[idx].status = 'free';
        state.fees[idx].amount = 0;
        logistics.status = 'free';
      } else if (val === 'none') {
        state.fees[idx].status = 'none';
        state.fees[idx].amount = 0;
        logistics.status = 'none';
      /* CUSTOM_WILLCALL_BY_CLAUDE (Ryan 2026-09-17) — ⛔ THE SECOND LADDER, and the one that made
         the control inert. There are TWO change listeners on this select: the generic one in
         workstation-fees.js (which did set `pickup`) and this override, which re-derives the state
         from `val` and then calls `updateFeeDropdownOptions()`. A `val` this chain does not name
         falls out of the if/else having written nothing, and the repaint that follows snaps the
         label back to Pending. Shaped exactly like `none` — no amount, nothing to charge. */
      } else if (val === 'pickup') {
        state.fees[idx].status = 'pickup';
        state.fees[idx].amount = 0;
        logistics.status = 'pickup';
      } else if (val === 'quoted') {
        var qAmt = feeKey === 'shipping' ? state.freight.totalQuoted : state.installation.totalQuoted;
        state.fees[idx].status = 'value';
        state.fees[idx].amount = qAmt;
        logistics.status = 'quoted';
      } else if (val === 'value' && isAdmin) {
        state.fees[idx].status = 'value';
        logistics.status = 'quoted';
      } else if (val === 'pending') {
        state.fees[idx].status = 'pending';
        state.fees[idx].amount = 0;
        logistics.status = 'pending';
      }
      state.dirty = true;
      updateFeeDropdownOptions();
      Q.recalcTotals();
    });
  });

  /* Request button */
  var RESIDENCE_PATTERNS = ['', '-', 'na', 'n/a', 'none', 'residence', 'residential', 'home'];
  var requestWrap = wrap.querySelector('.rq-ws-fees__request-wrap');
  var requestBtn = wrap.querySelector('.rq-ws-fees__request-btn');
  var requestDropdown = wrap.querySelector('.rq-ws-fees__request-dropdown');
  var requestSubmit = wrap.querySelector('.rq-ws-fees__request-submit');
  var requestStatus = wrap.querySelector('.rq-ws-fees__request-status');
  var requestErrors = wrap.querySelector('.rq-ws-fees__request-errors');
  var requestCheckFreight = wrap.querySelector('.rq-ws-fees__request-check[data-request-type="freight"]');
  var requestCheckInstall = wrap.querySelector('.rq-ws-fees__request-check[data-request-type="installation"]');
  var requestSubFreight = wrap.querySelector('.rq-ws-fees__request-sub[data-request-sub="freight"]');
  var deliveryFlagInputs = requestSubFreight ? requestSubFreight.querySelectorAll('[data-delivery-flag]') : [];
  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) - installation scope sub-options. */
  var requestSubInstall = wrap.querySelector('.rq-ws-fees__request-sub[data-request-sub="installation"]');
  var installScopeInputs = requestSubInstall ? requestSubInstall.querySelectorAll('[data-install-scope]') : [];
  /* CUSTOM_FAMILYREQUEST_BY_CLAUDE (ONYX 6c08dd4d325f, Ryan 2026-10-10, RW-1379-A/B/C) - "Also request freight for" the job's other
     versions. Read when the drop-down opens: the chain (/quote-chain) and the job's one freight request (/family-freight). A
     version already in that request is ticked and locked with its date, so a rep can see it is covered and pressing again
     does nothing. After the save, the ticked ones go in ONE call (/request-freight-versions); the worker joins them to the
     job's request, so the supplier gets one email listing every version. A failed read just hides the boxes. */
  var requestFamily = wrap.querySelector('[data-request-family]');
  var _famSeq = 0;
  function hideFamilyBoxes() { if (requestFamily) { requestFamily.innerHTML = ''; requestFamily.style.display = 'none'; } }
  function loadFamilyBoxes() {
    if (!requestFamily) return;
    var ref = String(state.ref || '');
    if (!/-[A-Z]$/.test(ref) || !Q.API) { hideFamilyBoxes(); return; }
    var seq = ++_famSeq;
    Promise.all([
      Q.API.get('/quote-chain?ref=' + encodeURIComponent(ref)),
      Q.API.get('/family-freight?ref=' + encodeURIComponent(ref)).catch(function() { return null; })
    ]).then(function(r) {
      if (seq !== _famSeq) return;
      var chain = r[0] && Array.isArray(r[0].revisions) ? r[0].revisions : [];
      var fam = r[1] && r[1].open ? r[1] : null;
      /* CUSTOM_FAMILYSIBLINGQUOTE_BY_CLAUDE (Ryan 2026-10-11, RW-1494-B) - a version with freight already on its quote is greyed
         out: there is nothing to request for it from here. Its own Re-request (the "Items changed" banner) is on its screen. */
      var quoted = (r[1] && r[1].quoted) || {};
      var others = [];
      chain.forEach(function(x) { var v = x && x.reference; if (v && v !== ref && others.indexOf(v) === -1) others.push(v); });
      if (!others.length) { hideFamilyBoxes(); return; }
      var html = '<div class="rq-ws-fees__request-family-title">Also request freight for:</div>';
      others.forEach(function(v) {
        var had = fam && fam.versions && fam.versions[v];
        var q = quoted[v];
        var qAge = q ? quoteAgeDays(q.appliedAt) : null;
        if (q && qAge != null && qAge > STALE_QUOTE_DAYS) {
          /* CUSTOM_STALEQUOTE_BY_CLAUDE - over 30 days old: tickable, and ticking it asks for a fresh quote on that version */
          var samt = q.free ? 'FREE' : '$' + Number(q.charged || 0).toFixed(2);
          html += '<label class="rq-ws-fees__request-suboption"><input type="checkbox" data-family-version="' + escAttr(v) + '"> ' + escHtml(v) + ' (<span class="rq-ws-fees__stale-age" style="color:#f59e0b;font-weight:600;">quoted ' + qAge + ' days ago</span>, ' + samt + ')</label>';
        } else if (q && q.itemsChanged !== false) {
          /* CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE (Ryan 2026-10-25, RW-1490) - its items changed since its quote (or it was last
             saved before the Workstation recorded that): tickable, and it joins this version's re-request, one supplier email */
          var cd = new Date(q.appliedAt || '');
          var cwhen = isNaN(cd.getTime()) ? '' : ' ' + (cd.getMonth() + 1) + '/' + cd.getDate();
          var camt = q.free ? 'FREE' : '$' + Number(q.charged || 0).toFixed(2);
          var cwhy = q.itemsChanged ? 'items changed since' : 'tick to re-quote';
          html += '<label class="rq-ws-fees__request-suboption"><input type="checkbox" data-family-version="' + escAttr(v) + '"> ' + escHtml(v) + ' (quoted' + cwhen + ', ' + camt + ', <span style="color:#f59e0b;font-weight:600;">' + cwhy + '</span>)</label>';
        } else if (q) {
          var qd = new Date(q.appliedAt || '');
          var qwhen = isNaN(qd.getTime()) ? '' : ' ' + (qd.getMonth() + 1) + '/' + qd.getDate();
          var qamt = q.free ? 'FREE' : '$' + Number(q.charged || 0).toFixed(2);
          html += '<label class="rq-ws-fees__request-suboption is-locked"><input type="checkbox" disabled> ' + escHtml(v) + ' (quoted' + qwhen + ', ' + qamt + ')</label>';
        } else if (had) {
          var d = new Date(had.requestedAt || '');
          var when = isNaN(d.getTime()) ? '' : ' ' + (d.getMonth() + 1) + '/' + d.getDate();
          html += '<label class="rq-ws-fees__request-suboption is-locked"><input type="checkbox" checked disabled> ' + escHtml(v) + ' (requested' + when + ')</label>';
        } else {
          html += '<label class="rq-ws-fees__request-suboption"><input type="checkbox" data-family-version="' + escAttr(v) + '"> ' + escHtml(v) + '</label>';
        }
      });
      requestFamily.innerHTML = html;
      requestFamily.style.display = '';
    }).catch(function() { if (seq === _famSeq) hideFamilyBoxes(); });
  }
  function pickedFamilyVersions() {
    if (!requestFamily) return [];
    var out = [];
    requestFamily.querySelectorAll('[data-family-version]').forEach(function(el) { if (el.checked) out.push(el.getAttribute('data-family-version')); });
    return out;
  }

  /* The indented delivery sub-options under "Freight Quote": shown whenever
     Freight Quote is offered, greyed and disabled while it is unticked
     (Ryan 2026-10-11; they used to hide unless ticked or already requested). Toggling a sub-option after the request
     marks state.dirty; the rep can then re-tick Freight Quote + Submit
     to re-notify admin, or just save quietly via the main Save button. */
  function syncDeliverySubVisibility() {
    if (!requestSubFreight || !requestCheckFreight) return;
    /* CUSTOM_REQUESTBOXES_BY_CLAUDE (Ryan 2026-10-11) - shown whenever Freight Quote is offered, greyed while it is
       unticked (was hidden unless ticked or already requested). */
    var fOpt = requestCheckFreight.closest('.rq-ws-fees__request-option');
    requestSubFreight.style.display = (!fOpt || fOpt.style.display !== 'none') ? '' : 'none';
    setSubEnabled(requestSubFreight, requestCheckFreight.checked);
    syncSubmitEnabled();
  }
  /* CUSTOM_REQUESTBOXES_BY_CLAUDE (Ryan 2026-10-11, RW-1494-B) - a sub-option under an UNTICKED parent is greyed out and
     cannot be clicked: ticked children under an unticked parent read as "Submit will still ask for this", and it won't. */
  function setSubEnabled(sub, on) {
    if (!sub) return;
    sub.style.opacity = on ? '' : '0.45';
    sub.setAttribute('aria-disabled', on ? 'false' : 'true');
    Array.prototype.forEach.call(sub.querySelectorAll('input'), function(i) { i.disabled = !on; });
  }
  /* ...and Submit Request is greyed out and unclickable until Freight or Installation (a shown one) is ticked. */
  function syncSubmitEnabled() {
    if (!requestSubmit) return;
    var picked = function(cb) {
      if (!cb || !cb.checked) return false;
      var opt = cb.closest('.rq-ws-fees__request-option');
      return !opt || opt.style.display !== 'none';
    };
    var on = picked(requestCheckFreight) || picked(requestCheckInstall);
    requestSubmit.disabled = !on;
    requestSubmit.style.opacity = on ? '' : '0.45';
    requestSubmit.style.cursor = on ? '' : 'not-allowed';
  }
  /* Initialize the 3 delivery checkboxes from state every time the dropdown
     opens or a quote loads — keeps the UI in sync with state.freight.deliveryConditions. */
  function syncDeliverySubChecked() {
    var dc = (state.freight && state.freight.deliveryConditions) || {};
    Array.prototype.forEach.call(deliveryFlagInputs, function(cb) {
      var flag = cb.getAttribute('data-delivery-flag');
      cb.checked = !!dc[flag];
      /* CUSTOM_FTLFLAG_BY_CLAUDE (Ryan 2026-10-22) - a full truckload has no inside delivery. */
      if (flag === 'insideDelivery') cb.disabled = !!dc.ftl;
    });
  }
  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) - installation scope, mirroring the freight
     delivery conditions directly above.

     Visible on the same terms: the rep ticked Installation Quote, or installation has already
     been requested and they are revisiting it. Neither box checked is the default and changes
     nothing, which is why the PDF prints nothing for it.

     MUTUAL EXCLUSION IS STRUCTURAL. state.installation.scope is one string, so checking Flooring
     writes 'flooring' and the Equipment box simply re-paints unchecked from that same value.
     There is no "uncheck the other one" branch to forget. Unchecking the active box clears it
     back to ''. */
  function syncInstallSubVisibility() {
    if (!requestSubInstall || !requestCheckInstall) return;
    var optionVisible = requestCheckInstall.closest('.rq-ws-fees__request-option');
    var canShow = !optionVisible || optionVisible.style.display !== 'none';
    requestSubInstall.style.display = canShow ? '' : 'none'; // CUSTOM_REQUESTBOXES_BY_CLAUDE - shown, greyed while unticked
    setSubEnabled(requestSubInstall, requestCheckInstall.checked);
    syncSubmitEnabled();
  }
  function syncInstallSubChecked() {
    var scope = (state.installation && state.installation.scope) || '';
    Array.prototype.forEach.call(installScopeInputs, function(cb) {
      cb.checked = cb.getAttribute('data-install-scope') === scope;
    });
  }
  Array.prototype.forEach.call(installScopeInputs, function(cb) {
    cb.addEventListener('change', function() {
      var val = this.getAttribute('data-install-scope');
      /* ⛔ Route through the SINGLE WRITER (workstation-freight.js) so the admin card's copy of
         these flags repaints too. Writing state.installation.scope directly here would leave the
         Installation Details card showing the previous value until something else repainted it -
         two controls over one field is exactly where a second writer starts telling a different
         story. Falls back to a direct write if freight.js has not mounted. */
      var next = this.checked ? val : '';
      if (Q.setInstallScope) {
        Q.setInstallScope(next);
      } else {
        if (!state.installation) state.installation = {};
        state.installation.scope = next;
        state.dirty = true;
      }
      syncInstallSubChecked();
    });
  });
  if (requestCheckInstall) {
    requestCheckInstall.addEventListener('change', syncInstallSubVisibility);
  }

  Array.prototype.forEach.call(deliveryFlagInputs, function(cb) {
    cb.addEventListener('change', function() {
      var flag = this.getAttribute('data-delivery-flag');
      if (Q.setDeliveryFlag) Q.setDeliveryFlag(flag, this.checked);
      if (flag === 'ftl') syncDeliverySubChecked(); // CUSTOM_FTLFLAG_BY_CLAUDE - FTL clears and locks inside delivery
    });
  });

  /* CUSTOM_STALEQUOTE_BY_CLAUDE (Ryan 2026-10-11, RW-1494-A) - a freight quote is good for 30 days. From day 31 the
     version offers "Re-Request Quote" (orange), its freight amount is flagged orange, and Submit asks the agent for a
     fresh figure (it refreshes from the weights and dims on file). Twin of lib/family-sibling-quote.js staleQuoteOf:
     same 30, same whole days, same "the freight is on the quote" test (Shipping row $ or FREE). */
  var STALE_QUOTE_DAYS = 30;
  function quoteAgeDays(appliedAt) {
    var t = Date.parse(appliedAt || '');
    if (!isFinite(t)) return null;
    return Math.floor((Date.now() - t) / 86400000);
  }
  function freightStaleDays() {
    var f = state.freight || {};
    var fee = state.fees && state.fees[0];
    if (f.status !== 'quoted' || !fee || (fee.status !== 'value' && fee.status !== 'free')) return null;
    var d = quoteAgeDays(f.appliedAt);
    return d != null && d > STALE_QUOTE_DAYS ? d : null;
  }
  function paintStaleFreight(days) {
    var inp = wrap.querySelector('.rq-ws-fees__input[data-fee="shipping"]');
    if (!inp) return;
    if (days != null) {
      inp.style.borderColor = '#f59e0b';
      inp.style.boxShadow = '0 0 0 1px #f59e0b';
      inp.style.color = '#f59e0b';
      inp.title = 'Quoted ' + days + ' days ago. Freight quotes are good for 30 days: use Re-Request for a fresh one.';
    } else {
      inp.style.borderColor = ''; inp.style.boxShadow = ''; inp.style.color = ''; inp.title = '';
    }
  }
  /* CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE (Ryan 2026-10-25, RW-1490-A/-B) - WHAT MOVED SINCE FREIGHT WAS QUOTED, IN WORDS.
     The same comparison the "Items changed" banner always made (the vendor-by-vendor snapshot taken when freight was requested
     or applied, against the items now), read item by item so it can say "Rally removed, Motivate added" or "203 -> 220"
     instead of "ECORE items changed". null = nothing moved, or freight is not quoted. It also drives the Fees & Extras
     Re-Request button: a quoted freight whose items changed used to have NO request button there at all. */
  /* CUSTOM_FREIGHTCHANGERULE_BY_CLAUDE (Ryan 2026-10-28, RW-1530-A) - a quantity of "?" is a product whose quantity at
     apply time is not known (a baseline rebuilt from a saved copy, see healFreightBaseline): it can be removed, never
     "changed by 15%". */
  function snapTokens(list) {
    var m = {};
    (list || []).forEach(function(entry) {
      var i = entry.indexOf(':');
      if (i === -1) return;
      var v = entry.slice(0, i), items = {};
      entry.slice(i + 1).replace(/(.*?)\u00d7([\d.]+|\?)(?=,|$),?/g, function(_, tok, qty) { if (tok) items[tok] = qty; return ''; });
      m[v] = items;
    });
    return m;
  }
  /* CUSTOM_FREIGHTCHANGERULE_BY_CLAUDE (Ryan 2026-10-28: "if quantities change by x %, or if a product is deleted, or if a
     new product with the 'freight-quoted' tag is added"; x = 15) - WHAT COUNTS AS A CHANGE. Any one of: a product's quantity
     moved more than 15% from what freight was quoted on, a product that was on it is gone, or a product the storefront
     tags `freight-quoted` (the catalogue's `fq`) was added. A swap is a removal plus an add. Adding a parcel product, or
     nudging a quantity 15% or less, is not a change: the freight still fits. */
  var FREIGHT_QTY_CHANGE_PCT = 15;
  function itemIsFreightQuoted(tok) {
    for (var i = 0; i < state.items.length; i++) {
      var it = state.items[i];
      if ((it.sku || it.title) !== tok) continue;
      var c = it.productHandle && Q.catalogByHandle && Q.catalogByHandle[it.productHandle];
      if (c && c.fq) return true;
    }
    return false;
  }
  function qtyMovedPastLimit(was, now) {
    var a = parseFloat(was), b = parseFloat(now);
    if (!isFinite(a) || !isFinite(b)) return false;
    if (a <= 0) return b > 0;
    return Math.abs(b - a) / a * 100 > FREIGHT_QTY_CHANGE_PCT;
  }
  function freightItemsChange() {
    var f = state.freight || {};
    if (f.status !== 'quoted' || !Array.isArray(f.itemsSnapshot) || !f.itemsSnapshot.length || !Q.buildItemsSnapshot) return null;
    var cur = Q.buildItemsSnapshot();
    if (JSON.stringify(cur) === JSON.stringify(f.itemsSnapshot)) return null;
    var was = snapTokens(f.itemsSnapshot), now = snapTokens(cur), parts = [];
    var nameOf = function(tok) {
      for (var i = 0; i < state.items.length; i++) { var it = state.items[i]; if ((it.sku || it.title) === tok) return it.title || tok; }
      return tok;
    };
    var vendors = Object.keys(now).concat(Object.keys(was).filter(function(v) { return !(v in now); }));
    vendors.forEach(function(v) {
      var w = was[v] || {}, n = now[v] || {}, bits = [];
      Object.keys(w).forEach(function(t) {
        if (!(t in n)) bits.push(nameOf(t) + ' removed');
        else if (qtyMovedPastLimit(w[t], n[t])) bits.push(nameOf(t) + ' ' + w[t] + ' \u2192 ' + n[t]);
      });
      Object.keys(n).forEach(function(t) { if (!(t in w) && itemIsFreightQuoted(t)) bits.push(nameOf(t) + ' added'); });
      if (bits.length) parts.push(v + ': ' + bits.join(', '));
    });
    if (!parts.length) return null;
    /* a Save As copies the freight with the items: a price applied before this version existed came from another version */
    var made = Date.parse(state.quoteCreatedAt || ''), applied = Date.parse(f.appliedAt || '');
    return { parts: parts, sig: JSON.stringify(cur), copied: isFinite(made) && isFinite(applied) && applied < made };
  }
  Q.freightItemsChange = freightItemsChange;
  /* CUSTOM_FREIGHTFITS_BY_CLAUDE (Ryan 2026-10-30, RW-1514-B: 12 UltraTiles off, three custom 4'x4' platforms of the same 12
     tiles on; the CUSTOM line's "3" cannot tell this page that) - AN ADMIN SAYS THE FREIGHT STILL COVERS THESE ITEMS. The
     items now on the quote become the list freight is measured against, so the warnings, the send question and the
     server's checks stand down until the items move again; the price stays. The next save stamps who and when and writes
     one deal-feed line (worker lib/freight-fits.js, which refuses it from anybody but an admin). Admins only, Ryan's pick. */
  function confirmFreightFits(ch) {
    if (!isAdmin || !ch || !Q.buildItemsSnapshot) return false;
    state.freight.itemsSnapshot = Q.buildItemsSnapshot();
    state.freight.fitsConfirmed = { at: new Date().toISOString(), changes: ch.parts.slice(0, 10), copied: !!ch.copied };
    state.dirty = true;
    return true;
  }
  Q.confirmFreightFits = confirmFreightFits;
  /* CUSTOM_FREIGHTCHANGERULE_BY_CLAUDE (Ryan 2026-10-28, RW-1530-A) - FREIGHT ON THE QUOTE WITH NO RECORD OF ITS ITEMS.
     The list above is only written by this page (Request Quote, Apply). Freight an agent or the auto-apply put on a version
     the QW never asked for (a sibling ticked into another version's request) arrives with none, so every warning stayed
     silent for good: 142 of 546 quoted deals on 2026-10-28. Called on load, after the items:
     - not saved since freight went on (`lastSavedAt` moves only when a save changes something): the items on the quote ARE
       the items it was quoted on, so they are the list;
     - saved since: the worker rebuilds the product list from the saved copy taken just before that save, quantities
       unknown ("?"), so a removed product still counts. Nothing found = no list, as before. */
  function healFreightBaseline(meta, ref) {
    var f = state.freight;
    if (!f || f.status !== 'quoted' || !f.appliedAt || (Array.isArray(f.itemsSnapshot) && f.itemsSnapshot.length)) return;
    if (!state.items.length || !Q.buildItemsSnapshot) return;
    var saved = Date.parse((meta && meta.lastSavedAt) || ''), applied = Date.parse(f.appliedAt);
    if (!isFinite(saved) || !isFinite(applied) || saved <= applied) { f.itemsSnapshot = Q.buildItemsSnapshot(); return; }
    if (!ref || !Q.API) return;
    Q.API.get('/freight-items-baseline?ref=' + encodeURIComponent(ref)).then(function(res) {
      if (state.ref !== ref || !res || !Array.isArray(res.itemsSnapshot) || !res.itemsSnapshot.length) return;
      if (Array.isArray(state.freight.itemsSnapshot) && state.freight.itemsSnapshot.length) return;
      state.freight.itemsSnapshot = res.itemsSnapshot;
      if (Q.checkFreightStaleness) Q.checkFreightStaleness();
    }).catch(function() { /* no list, as before */ });
  }
  Q.healFreightBaseline = healFreightBaseline;
  function installRequestable() {
    var st = String((state.installation && state.installation.status) || 'pending');
    return st !== 'none';
  }
  /* CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE (Ryan 2026-10-25: the "Items changed..." line made the pop-up "way wider/longer...
     goofy") - what moved is a hover note ABOVE the Re-Request button, and the pop-up keeps its compact shape. Hidden while the
     pop-up is open (`is-open` on the anchor). Styled here, like the Workstation's other JS-built boxes. */
  var _tipStyled = false;
  function paintRequestTip(text) {
    var anchor = requestBtn && requestBtn.closest('.rq-ws-fees__request-anchor');
    if (!anchor) return;
    if (!_tipStyled && document.head) {
      _tipStyled = true;
      var st = document.createElement('style');
      st.textContent =
        '.rq-ws-fees__request-tip{display:none;position:absolute;right:0;bottom:calc(100% + 8px);width:280px;max-width:80vw;padding:8px 10px;background:var(--rq-bg);border:1px solid #f59e0b;border-radius:6px;color:var(--rq-text);font-size:12px;line-height:1.45;text-align:left;box-shadow:0 6px 18px rgba(0,0,0,0.35);z-index:30;pointer-events:none}' +
        '.rq-ws-fees__request-btn:hover~.rq-ws-fees__request-tip,.rq-ws-fees__request-btn:focus-visible~.rq-ws-fees__request-tip{display:block}' +
        '.rq-ws-fees__request-anchor.is-open .rq-ws-fees__request-tip{display:none!important}';
      document.head.appendChild(st);
    }
    var tip = anchor.querySelector('.rq-ws-fees__request-tip');
    if (!text) { if (tip) tip.parentNode.removeChild(tip); return; }
    if (!tip) { tip = document.createElement('div'); tip.className = 'rq-ws-fees__request-tip'; tip.setAttribute('role', 'tooltip'); anchor.appendChild(tip); }
    tip.textContent = text;
  }
  function markRequestOpen(on) {
    var anchor = requestBtn && requestBtn.closest('.rq-ws-fees__request-anchor');
    if (anchor) anchor.classList.toggle('is-open', !!on);
  }
  function updateRequestButton() {
    if (!requestWrap) return;
    var freightPending = state.freight.status === 'pending';
    /* CUSTOM_REQUESTBOXES_BY_CLAUDE (Ryan 2026-10-11) - installation is requestable from ANY state but None: a FREE or $
       installation still costs us, so a price can be asked for. Requesting it does not touch what the customer sees
       (the fee row stays FREE / $); it only stamps the request. */
    var installPending = installRequestable() && state.installation.status !== 'requested';
    var freightRequested = state.freight.status === 'requested';
    var installRequested = state.installation.status === 'requested';
    var staleDays = freightStaleDays(); // CUSTOM_STALEQUOTE_BY_CLAUDE
    /* CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE - a version a sibling's Re-Request handed over (the server cleared its snapshot):
       the items on screen are the items that request is for. */
    if (state.freight.status === 'requested' && state.freight.itemsSnapshotPending && Q.buildItemsSnapshot && state.items.length) {
      state.freight.itemsSnapshot = Q.buildItemsSnapshot();
      delete state.freight.itemsSnapshotPending;
    }
    var itemsChange = freightItemsChange(); // CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE - re-requestable, like a stale quote
    var freightStale = staleDays != null || !!itemsChange;
    paintStaleFreight(staleDays);
    // Show on unsaved quotes too — clicking Request Quote on a new quote saves
    // first (handler at the bottom already calls Q.saveDraft), so the worker
    // creates the draft + notifies admins in one round-trip.
    /* CUSTOM_OFFLINEDIMSONFILE_BY_CLAUDE (Ryan 2026-10-01, RW-1469-A) — ADMINS GET THE HAND-OFF TOO.
       This widget used to hide for admins, so an admin's only freight doors were the panel's
       ✉ Freight / ✉ Wt/Dims emails and the agents were never handed the job. Its Freight Quote
       box is the same request a rep makes: the save wakes the agents, who quote from packaged
       dims already on file when every line has them and otherwise ask the supplier. The ✉ buttons
       stay for when an admin wants to pick the channel. Installation shows for admins too since 2026-10-11:
       the request emails Ryan only, his to-do reminder (CUSTOM_INSTALLREQEMAIL_BY_CLAUDE). */

    var hasRequested = freightRequested || installRequested;
    var hasPending = freightPending || installPending;
    var showWrap = hasPending || hasRequested || freightStale;
    requestWrap.style.display = showWrap ? '' : 'none';
    /* the button itself: "Re-Request Quote" in orange when a stale freight quote is the reason it shows */
    if (requestBtn) {
      var _restale = freightStale && !hasPending && !hasRequested;
      /* Ryan 2026-10-23: "Re-Request", and it hovers orange - the inline orange text used to sit on the button's default
         blue hover. A class now, so the stylesheet owns both states. */
      requestBtn.textContent = _restale ? 'Re-Request' : 'Request Quote';
      requestBtn.classList.toggle('rq-ws-fees__request-btn--stale', _restale);
      requestBtn.style.borderColor = '';
      requestBtn.style.color = '';
    }
    paintRequestTip(itemsChange ? 'Items changed since freight was quoted: ' + itemsChange.parts.join('; ') + '. Re-Request asks for a new quote.' : '');
    if (!showWrap) return;
    if (requestDropdown) requestDropdown.style.display = 'none';
    markRequestOpen(false);

    if (requestStatus) {
      if (hasRequested) {
        var lines = [];
        if (freightRequested && state.freight.requestedAt) {
          var fd = new Date(state.freight.requestedAt);
          lines.push('✓ Freight requested on ' + (fd.getMonth() + 1) + '/' + fd.getDate());
        } else if (freightRequested) {
          lines.push('✓ Freight requested');
        }
        if (installRequested && state.installation.requestedAt) {
          var id = new Date(state.installation.requestedAt);
          lines.push('✓ Installation requested on ' + (id.getMonth() + 1) + '/' + id.getDate());
        } else if (installRequested) {
          lines.push('✓ Installation requested');
        }
        requestStatus.innerHTML = lines.join('<br>');
        requestStatus.style.display = '';
      } else {
        requestStatus.style.display = 'none';
      }
    }

    var requestAnchor = requestBtn ? requestBtn.closest('.rq-ws-fees__request-anchor') : null;
    // Button stays accessible after the request lands too — rep needs a way
    // back into the dropdown to update delivery conditions / resend the
    // notification if they forgot a flag.
    var showBtn = hasPending || hasRequested || freightStale;
    if (requestAnchor) requestAnchor.style.display = showBtn ? '' : 'none';

    var canRequestFreight = freightPending || freightRequested || freightStale;
    var canRequestInstall = installPending || installRequested;
    if (requestCheckFreight) {
      // Auto-check only on the clean first-request flow. Once freight has
      // already been requested, the rep deliberately re-ticks this box to
      // signal "resend with current conditions" — submit then re-stamps
      // requestedAt and the worker fires an update notification.
      /* CUSTOM_REQUESTBOXES_BY_CLAUDE (Ryan 2026-10-11, RW-1494-B) - ticked when already requested too: the delivery
         sub-boxes showed ticked under an unticked parent, which read as broken. A line says Submit sends it again (an
         unpriced request still waiting on the supplier is a no-op for the agents; a priced one is a re-request). */
      requestCheckFreight.checked = freightPending || freightRequested || freightStale;
      var _fOpt = requestCheckFreight.closest('.rq-ws-fees__request-option');
      _fOpt.style.display = canRequestFreight ? '' : 'none';
      var _resend = _fOpt.querySelector('.rq-ws-fees__request-resend');
      if ((freightRequested || freightStale) && !itemsChange) { // CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE - that one is the hover note
        if (!_resend) { _resend = document.createElement('span'); _resend.className = 'rq-ws-fees__request-resend'; _resend.style.cssText = 'display:block;font-size:11px;opacity:.75;margin-left:22px;'; _fOpt.appendChild(_resend); }
        if (freightStale) {
          _resend.textContent = 'Freight was quoted ' + staleDays + ' days ago. Submit asks for a fresh quote.';
          _resend.style.color = '#f59e0b';
        } else {
          var _fd = new Date(state.freight.requestedAt || '');
          _resend.textContent = 'Freight was requested' + (isNaN(_fd.getTime()) ? '' : ' on ' + (_fd.getMonth() + 1) + '/' + _fd.getDate()) + '. Submit sends it again.';
          _resend.style.color = '';
        }
      } else if (_resend) { _resend.parentNode.removeChild(_resend); }
    }
    if (requestCheckInstall) {
      // Installation defaults unchecked even when requestable — most "Request
      // Quote" clicks are freight-only. Rep ticks the Install box explicitly
      // when they want it. Visibility (show the option at all) still respects
      // canRequestInstall.
      /* CUSTOM_REQUESTBOXES_BY_CLAUDE (Ryan 2026-10-11) - shown to admins too: the request now emails Ryan (only), which
         is his to-do reminder, even on his own quotes. Ticked for you only when it is the one thing to request. */
      requestCheckInstall.checked = installPending && !canRequestFreight;
      requestCheckInstall.closest('.rq-ws-fees__request-option').style.display = canRequestInstall ? '' : 'none';
    }
    syncDeliverySubVisibility();
    syncInstallSubVisibility();
  }

  function validateFreightRequest() {
    var errors = [];
    var zipMissing = false;
    if (state.items.length === 0) errors.push('Add at least one item to the quote');
    var customer = Q.getCustomerData();
    var wantFreight = requestCheckFreight && requestCheckFreight.checked;
    var wantInstall = requestCheckInstall && requestCheckInstall.checked;
    // Zip is required for both freight AND install — vendors/installers can't
    // quote without a destination. Ship To zip wins when a separate Ship To
    // address is on; otherwise the Sold To zip is the destination.
    if (wantFreight || wantInstall) {
      var destZip = (customer.hasShipTo ? customer.shipZip : customer.zip) || '';
      if (!destZip.trim()) {
        errors.push('Zip code is required to request a freight or install quote');
        zipMissing = true;
      }
    }
    return { errors: errors, zipMissing: zipMissing, useShipTo: !!customer.hasShipTo };
  }

  if (requestBtn) {
    requestBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      if (requestDropdown) {
        var isOpen = requestDropdown.style.display !== 'none';
        requestDropdown.style.display = isOpen ? 'none' : '';
        markRequestOpen(!isOpen); // CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE - the hover note hides while the pop-up is open
        if (requestErrors) requestErrors.style.display = 'none';
        // Re-sync the delivery checkboxes from state and the sub-block's
        // visibility in case Freight Quote was toggled previously.
        if (!isOpen) {
          syncDeliverySubChecked();
          syncDeliverySubVisibility();
          syncInstallSubChecked();
          syncInstallSubVisibility();
          loadFamilyBoxes(); // CUSTOM_FAMILYREQUEST_BY_CLAUDE
        }
      }
    });
  }
  if (requestCheckFreight) {
    requestCheckFreight.addEventListener('change', syncDeliverySubVisibility);
  }

  document.addEventListener('click', function() {
    if (requestDropdown) requestDropdown.style.display = 'none';
    markRequestOpen(false);
  });
  if (requestDropdown) {
    requestDropdown.addEventListener('click', function(e) { e.stopPropagation(); });
  }

  if (requestSubmit) {
    requestSubmit.addEventListener('click', function() {
      var wantFreight = requestCheckFreight && requestCheckFreight.checked;
      var wantInstall = requestCheckInstall && requestCheckInstall.checked;
      if (!wantFreight && !wantInstall) {
        if (requestErrors) {
          requestErrors.textContent = 'Select at least one option';
          requestErrors.style.display = '';
        }
        return;
      }

      var validation = validateFreightRequest();
      if (validation.errors.length) {
        if (requestErrors) {
          requestErrors.innerHTML = validation.errors.map(function(e) { return '• ' + e; }).join('<br>');
          requestErrors.style.display = '';
        }
        if (validation.zipMissing) {
          var which = validation.useShipTo ? 'Ship To' : 'Sold To';
          var fieldName = validation.useShipTo ? 'shipZip' : 'zip';
          alert('Add a zip code before submitting this request.\n\nThe ' + which + ' address needs a zip code so freight and install vendors can quote accurately.');
          var zipInput = wrap.querySelector('[data-field="' + fieldName + '"]');
          if (zipInput) {
            zipInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function() { zipInput.focus(); }, 400);
          }
        }
        return;
      }
      if (requestErrors) requestErrors.style.display = 'none';

      var now = new Date().toISOString();
      var sess = JSON.parse(sessionStorage.getItem('rep_portal_session') || '{}');
      var repCode = sess.code || '';

      if (wantFreight && (state.freight.status === 'pending' || state.freight.status === 'requested' || freightStaleDays() != null || freightItemsChange())) { // CUSTOM_STALEQUOTE_BY_CLAUDE + CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE
        state.freight.status = 'requested';
        state.freight.requestedAt = now;
        state.freight.requestedBy = repCode;
        /* CUSTOM_QWAPPLIEDSIG_BY_CLAUDE (Ryan 2026-10-11, RW-1494-A/-B) — ⛔ THE ITEMS THE FREIGHT IS
           QUOTED ON ARE THE ITEMS AT REQUEST TIME. The "Items changed since freight was quoted"
           banner (and its Re-request button) compares against `itemsSnapshot`, which only the QW's
           own Apply wrote. An agent or auto-apply runs in the worker, which has no line quantities,
           so every agent-quoted deal kept an empty snapshot and the banner could never fire: 15
           tiles went to 20 on RW-1494 with nothing offering a re-quote. Taken here, the worker's
           apply carries it through untouched; a QW Apply still re-takes it at apply time. */
        if (Q.buildItemsSnapshot) state.freight.itemsSnapshot = Q.buildItemsSnapshot();
      }
      if (wantInstall && installRequestable()) { // CUSTOM_REQUESTBOXES_BY_CLAUDE - FREE / $ / quoted too
        state.installation.status = 'requested';
        state.installation.requestedAt = now;
        state.installation.requestedBy = repCode;
      }

      state.dirty = true;
      updateFeeDropdownOptions();

      /* CUSTOM_FAMILYREQUEST_BY_CLAUDE (ONYX 6c08dd4d325f) - the ticked versions, sent after THIS version is saved so it is in the
         job's request first. */
      var famPicked = wantFreight ? pickedFamilyVersions() : [];
      var famRef = state.ref;
      var saveBtn = wrap.querySelector('.rq-ws-send__save');
      if (saveBtn) {
        var saving = Q.saveDraft(saveBtn);
        if (famPicked.length && saving && typeof saving.then === 'function' && Q.API) {
          saving.then(function(res) {
            if (res && res.saved === false) return;
            return Q.API.post('/request-freight-versions', { ref: famRef, versions: famPicked }).then(function(d) {
              var joined = (d && d.joined) || [];
              var refused = (d && d.refused) || [];
              if (joined.length) showToast('Freight also requested for ' + joined.join(', ') + '. They are part of this job\'s one freight request, so the supplier gets one email listing every version.', 'success');
              else if (!refused.length) showToast('Those versions were already part of this job\'s freight request.', 'info');
              if (refused.length) showToast('Not requested: ' + refused.map(function(x) { return x.ref + ' (' + x.why + ')'; }).join(', '), 'warning');
            });
          }).catch(function(e) { showToast('Could not request the other versions: ' + ((e && e.message) || 'error'), 'error'); });
        }
      }
    });
  }

  /* Quote age counter */
  var ageEl = wrap.querySelector('.rq-ws-bar__age');
  function updateQuoteAge(createdAt) {
    state.quoteCreatedAt = createdAt || null; // CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE - see freightItemsChange
    if (!ageEl || !createdAt) { if (ageEl) ageEl.style.display = 'none'; return; }
    var created = new Date(createdAt);
    if (isNaN(created.getTime())) { ageEl.style.display = 'none'; return; }
    var days = Math.floor((Date.now() - created.getTime()) / (1000 * 60 * 60 * 24));
    ageEl.textContent = days + 'd ago';
    ageEl.className = 'rq-ws-bar__age';
    if (days >= 30) ageEl.classList.add('rq-ws-bar__age--urgent');
    else if (days >= 23) ageEl.classList.add('rq-ws-bar__age--warning');
    ageEl.style.display = '';
  }

  /* ── Bulk Actions ── */
  var bulkBtn = wrap.querySelector('.rq-ws-bulk-wrap__btn');
  var bulkDrop = wrap.querySelector('.rq-ws-bulk-wrap__dropdown');
  bulkBtn && bulkBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    if (Q.customWrap) Q.customWrap.classList.remove('rq-ws-custom-add-wrap--open');
    bulkDrop.classList.toggle('rq-ws-bulk-wrap__dropdown--open');
  });

  bulkDrop && bulkDrop.querySelectorAll('button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var action = this.getAttribute('data-action');
      bulkDrop.classList.remove('rq-ws-bulk-wrap__dropdown--open');
      handleBulkAction(action);
    });
  });

  /* ── Bulk Action Modal Logic ── */
  var bulkModal = wrap.querySelector('.rq-ws-bulk-modal');
  var bulkModalScope = bulkModal.querySelector('.rq-ws-bulk-modal__scope');
  var bulkModalInput = bulkModal.querySelector('.rq-ws-bulk-modal__input');
  var bulkModalValueWrap = bulkModal.querySelector('.rq-ws-bulk-modal__value-wrap');
  var bulkModalState = { action: null, selectedScope: 'all' };

  function getQuoteVendors() {
    var seen = {};
    var vendors = [];
    state.items.forEach(function(i) {
      if (!seen[i.vendor]) { seen[i.vendor] = true; vendors.push(i.vendor); }
    });
    return vendors;
  }

  function openBulkModal(action) {
    if (state.items.length === 0) return;
    bulkModalState.action = action;
    bulkModalState.selectedScope = 'all';

    var config = {
      'set-pts':      { title: 'Set Points',      valueLabel: 'Points', placeholder: '30', needsValue: true },
      'add-pts':      { title: 'Add Points',       valueLabel: 'Points to add', placeholder: '5', needsValue: true },
      'subtract-pts': { title: 'Subtract Points',  valueLabel: 'Points to subtract', placeholder: '5', needsValue: true },
      'discount-pct': { title: 'Discount by %',    valueLabel: 'Discount percentage', placeholder: '10', needsValue: true },
      'reset-map':    { title: 'Reset to MAP',     needsValue: false },
      'match-msrp':   { title: 'Match MSRP',       needsValue: false }
    };
    var c = config[action] || {};

    bulkModal.querySelector('.rq-ws-bulk-modal__title').textContent = c.title || action;

    var vendors = getQuoteVendors();
    var html = '<button class="rq-ws-bulk-modal__scope-pill rq-ws-bulk-modal__scope-pill--selected" data-scope="all" type="button">All Items</button>';
    vendors.forEach(function(v) {
      html += '<button class="rq-ws-bulk-modal__scope-pill" data-scope="' + escAttr(v) + '" type="button">' + escHtml(v) + '</button>';
    });
    bulkModalScope.innerHTML = html;

    if (c.needsValue) {
      bulkModalValueWrap.style.display = '';
      bulkModal.querySelector('.rq-ws-bulk-modal__value-label').textContent = c.valueLabel || 'Value';
      bulkModalInput.value = '';
      bulkModalInput.placeholder = c.placeholder || '';
    } else {
      bulkModalValueWrap.style.display = 'none';
    }

    bulkModal.style.display = '';
    if (c.needsValue) setTimeout(function() { bulkModalInput.focus(); }, 50);
  }

  function closeBulkModal() {
    bulkModal.style.display = 'none';
    bulkModalState.action = null;
  }

  function applyBulkAction() {
    var action = bulkModalState.action;
    var scope = bulkModalState.selectedScope;
    var val = parseFloat(bulkModalInput.value);

    function matchesScope(item) {
      return scope === 'all' || item.vendor === scope;
    }

    if (action === 'set-pts') {
      if (isNaN(val)) return;
      state.items.forEach(function(i) {
        if (!matchesScope(i)) return;
        i.points = val;
        i.directPrice = calculateDirect(i.cost, i.points);
      });
    } else if (action === 'add-pts') {
      if (isNaN(val)) return;
      state.items.forEach(function(i) {
        if (!matchesScope(i)) return;
        i.points = Math.min(99.9, i.points + val);
        i.directPrice = calculateDirect(i.cost, i.points);
      });
    } else if (action === 'subtract-pts') {
      if (isNaN(val)) return;
      state.items.forEach(function(i) {
        if (!matchesScope(i)) return;
        i.points = Math.max(0, i.points - val);
        i.directPrice = calculateDirect(i.cost, i.points);
      });
    } else if (action === 'discount-pct') {
      if (isNaN(val)) return;
      state.items.forEach(function(i) {
        if (!matchesScope(i)) return;
        i.directPrice = Math.round(i.directPrice * (1 - val / 100) * 100) / 100;
        i.points = reversePoints(i.cost, i.directPrice);
      });
    } else if (action === 'reset-map') {
      state.items.forEach(function(i) {
        if (!matchesScope(i)) return;
        if (i.mapPrice > 0) {
          i.directPrice = i.mapPrice;
          i.points = reversePoints(i.cost, i.directPrice);
        }
      });
    } else if (action === 'match-msrp') {
      state.items.forEach(function(i) {
        if (!matchesScope(i)) return;
        if (i.msrp > 0) {
          i.directPrice = i.msrp;
          i.points = reversePoints(i.cost, i.msrp);
        }
      });
    }

    closeBulkModal();
    Q.renderItems();
  }

  bulkModalScope.addEventListener('click', function(e) {
    var pill = e.target.closest('.rq-ws-bulk-modal__scope-pill');
    if (!pill) return;
    bulkModalScope.querySelectorAll('.rq-ws-bulk-modal__scope-pill').forEach(function(p) {
      p.classList.remove('rq-ws-bulk-modal__scope-pill--selected');
    });
    pill.classList.add('rq-ws-bulk-modal__scope-pill--selected');
    bulkModalState.selectedScope = pill.getAttribute('data-scope');
  });

  bulkModal.querySelector('.rq-ws-bulk-modal__apply').addEventListener('click', applyBulkAction);
  bulkModal.querySelector('.rq-ws-bulk-modal__cancel').addEventListener('click', closeBulkModal);
  bulkModal.querySelector('.rq-ws-bulk-modal__backdrop').addEventListener('click', closeBulkModal);
  bulkModalInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); applyBulkAction(); }
    if (e.key === 'Escape') closeBulkModal();
  });

  function handleBulkAction(action) {
    openBulkModal(action);
  }

  /* CUSTOM_QWALERTS_BY_CLAUDE (Ryan 2026-10-23) - THE ALERTS BANNER. Every page-level alert is one row here, never a
     banner of its own somewhere else on the page. Two kinds: (1) a provider in Q.alertProviders: fn(state) -> {id,
     level:'red'|'orange'|'yellow', icon, head, text, sig, action?:{label, run(btn)}} or null, re-asked on every draw
     (it reads the quote, so it comes and goes with it); (2) a one-off alert another module shows when something HAPPENS
     (Q.showAlert / Q.hideAlert: a save's freight notice, a lookup's answer). Sorted red, orange, yellow. A dismissed
     provider alert stays gone on that quote until its `sig` changes (remembered in this browser only); a one-off alert
     with `persist: false` just goes, and runs its `onDismiss`. `quoteScoped` one-offs clear when another quote loads.
     Pass 2 moved here: open lead, unsaved quote, paid through Shopify, items changed since freight was quoted, lines at
     $0, freight kept / request cancelled by a save, catalog stale. */
  var alertsBox = wrap.querySelector('.rq-ws-alerts');
  var ALERT_RANK = { red: 0, orange: 1, yellow: 2 };
  Q.alertProviders = Q.alertProviders || [];
  var oneOffAlerts = {};
  function alertDismissKey(id) { return 'rqws-alert-x:' + (state.ref || '') + ':' + id; }
  /* An alert with `dismissFor` (ms) comes back after that long even when nothing changed (Ryan 2026-10-23: the freight
     alert "should come back every new day"); the stored value is then {sig, at}. Everything else stays dismissed until
     its `sig` changes. */
  function alertDismissed(a) {
    if (a.persist === false) return false;
    try {
      var v = localStorage.getItem(alertDismissKey(a.id));
      if (v == null) return false;
      var sig = String(a.sig || '1');
      if (v.charAt(0) === '{') {
        var o = JSON.parse(v);
        if (o.sig !== sig) return false;
        return !(a.dismissFor > 0) || (Date.now() - (Number(o.at) || 0)) < a.dismissFor;
      }
      return v === sig && !(a.dismissFor > 0);
    } catch (e) { return false; }
  }
  function rememberDismiss(a) {
    var sig = String(a.sig || '1');
    try { localStorage.setItem(alertDismissKey(a.id), a.dismissFor > 0 ? JSON.stringify({ sig: sig, at: Date.now() }) : sig); } catch (e) { /* stays for this view only */ }
  }
  function showAlert(a) { if (a && a.id) { oneOffAlerts[a.id] = a; renderAlerts(); } }
  function hideAlert(id) { if (oneOffAlerts[id]) { delete oneOffAlerts[id]; renderAlerts(); } }
  function clearQuoteAlerts() {
    Object.keys(oneOffAlerts).forEach(function (id) { if (oneOffAlerts[id].quoteScoped) delete oneOffAlerts[id]; });
    renderAlerts();
  }
  function renderAlerts() {
    if (!alertsBox) return;
    var list = [];
    Q.alertProviders.forEach(function (fn) {
      try { var a = fn(state); if (a && !alertDismissed(a)) list.push(a); } catch (e) { /* one bad provider never hides the rest */ }
    });
    Object.keys(oneOffAlerts).forEach(function (id) { var a = oneOffAlerts[id]; if (!alertDismissed(a)) list.push(a); });
    var rankOf = function (x) { return Object.prototype.hasOwnProperty.call(ALERT_RANK, x.level) ? ALERT_RANK[x.level] : 9; }; // red is 0, never `|| 9`
    list.sort(function (a, b) { return rankOf(a) - rankOf(b); });
    alertsBox.innerHTML = '';
    list.forEach(function (a) {
      var row = document.createElement('div');
      row.className = 'rq-ws-alert rq-ws-alert--' + a.level;
      row.setAttribute('role', 'status');
      row.title = a.head + '. ' + a.text;
      row.innerHTML = '<span class="rq-ws-alert__icon" aria-hidden="true">' + a.icon + '</span>'
        + '<span class="rq-ws-alert__head">' + escHtml(a.head) + '</span>'
        + '<span class="rq-ws-alert__text">' + escHtml(a.text) + '</span>'
        + (a.action ? '<button type="button" class="rq-ws-alert__act">' + escHtml(a.action.label) + '</button>' : '')
        + (a.action2 ? '<button type="button" class="rq-ws-alert__act rq-ws-alert__act--2">' + escHtml(a.action2.label) + '</button>' : '') // CUSTOM_FREIGHTFITS_BY_CLAUDE
        + '<button type="button" class="rq-ws-alert__x" title="Dismiss" aria-label="Dismiss">&times;</button>';
      if (a.action) row.querySelector('.rq-ws-alert__act').addEventListener('click', function () { a.action.run(this); });
      if (a.action2) row.querySelector('.rq-ws-alert__act--2').addEventListener('click', function () { a.action2.run(this); });
      row.querySelector('.rq-ws-alert__x').addEventListener('click', function () {
        if (a.persist !== false) rememberDismiss(a);
        if (oneOffAlerts[a.id] === a) delete oneOffAlerts[a.id];
        if (typeof a.onDismiss === 'function') { try { a.onDismiss(); } catch (e) { /* the row still goes */ } }
        row.remove();
        if (!alertsBox.children.length) alertsBox.hidden = true;
      });
      alertsBox.appendChild(row);
    });
    alertsBox.hidden = !list.length;
  }

  /* CUSTOM_QWALERTS_BY_CLAUDE - THE ONE WAY THIS PAGE REQUESTS FREIGHT. The Request Quote dropdown's Submit is the path
     (zip check, the requested stamp, the items snapshot, the save that wakes the agent); every other button ticks
     Freight and presses it, so no second implementation can drift. It used to be that the freight panel's
     "Re-request Freight Quote" only reset the status on screen and requested nothing. */
  /* CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE (Ryan 2026-10-25) - open Fees & Extras and the Request drop-down, so the rep sees what
     will be asked (delivery options, the other versions) before anything goes. Deferred: the click that called this is
     still bubbling, and the page-wide click closes the drop-down. */
  function openRequestDropdown() {
    var body = wrap.querySelector('.rq-ws-section--fees .rq-ws-section__body');
    var tog = wrap.querySelector('.rq-ws-section--fees .rq-ws-section__toggle');
    if (body && tog && !body.classList.contains('rq-ws-section__body--open')) tog.click();
    updateRequestButton();
    setTimeout(function() {
      if (!requestBtn) return;
      requestBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (requestDropdown && requestDropdown.style.display === 'none') requestBtn.click();
    }, 350);
  }
  function requestFreightNow() {
    if (!requestSubmit || !requestCheckFreight) return false;
    requestCheckFreight.checked = true;
    if (requestCheckInstall) requestCheckInstall.checked = false;
    requestSubmit.click();
    return true;
  }

  /* CUSTOM_FREIGHTPROMISE_BY_CLAUDE (Ryan 2026-10-23) - the 30-day freight promise has run out. `state.freightHold` comes
     from /quote-details, present only while the Freight Hub's 30-day switch is on and the deal is open. A new price
     waiting: Apply it (POST /freight-reprice-apply, then the quote reloads so a later save cannot write the old price
     back). No current rate: Re-request, through the dropdown's own Submit. */
  function holdMoney(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  Q.alertProviders.push(function freightPromiseAlert(st) {
    var h = st.freightHold;
    if (!h || !st.ref) return null;
    var t = Date.parse(h.sentAt || '');
    var days = isFinite(t) ? Math.floor((Date.now() - t) / 86400000) : null;
    var head = days != null ? 'Freight is ' + days + ' days old' : 'Freight is over 30 days old';
    var props = Array.isArray(h.proposals) ? h.proposals : [];
    if (props.length) {
      var from = 0, to = 0;
      props.forEach(function (p) { from += Number(p.from) || 0; to += Number(p.to) || 0; });
      var label = 'Apply ' + holdMoney(to);
      return { id: 'freight-promise', level: 'orange', icon: '&#x1F69A;', head: head, sig: 'p' + to.toFixed(2), dismissFor: 86400000,
        text: 'The freight rate has changed: ' + holdMoney(to) + ', ' + (to > from ? 'up' : 'down') + ' from ' + holdMoney(from) + '.',
        action: { label: label, run: function (btn) {
          var ref = st.ref;
          btn.disabled = true; btn.textContent = 'Applying...';
          var saveBtn = wrap.querySelector('.rq-ws-send__save');
          var pre = (st.dirty && Q.saveDraft && saveBtn) ? Q.saveDraft(saveBtn) : Promise.resolve({ saved: true });
          Promise.resolve(pre).then(function (r) {
            if (r && r.saved === false) throw new Error('save your changes first');
            return Q.API.post('/freight-reprice-apply', { ref: ref });
          }).then(function () {
            showToast('New freight price applied. The quote and pay link are updated.', 'success');
            Q.loadQuote(ref);
          }).catch(function (e) {
            btn.disabled = false; btn.textContent = label;
            showToast('Could not apply the new freight price: ' + ((e && e.message) || e), 'error');
          });
        } } };
    }
    if (days == null || days < 30) return null;
    if ((st.freight || {}).status === 'requested') return null; // already asked for; the request status says so
    return { id: 'freight-promise', level: 'orange', icon: '&#x1F69A;', head: head, sig: 'r' + (h.sentAt || ''), dismissFor: 86400000,
      text: 'The current freight rate has expired, time to request an updated one.',
      action: { label: 'Re-request', run: function () { requestFreightNow(); } } };
  });

  /* CUSTOM_QWALERTS_BY_CLAUDE (Pass 2) - the quote has been paid through Shopify (was the amber banner under the toolbar). */
  Q.alertProviders.push(function paidThroughShopifyAlert(st) {
    if (!st.paidThroughShopify) return null;
    return { id: 'paid-shopify', level: 'yellow', icon: '&#x1F4B3;', head: 'Paid through Shopify', sig: '1',
      text: 'Edits here save to our records, POs and the dashboard, but do not change the Shopify order. Ask an admin for refunds, re-orders or fulfillment changes.' };
  });

  /* CUSTOM_QWALERTS_BY_CLAUDE (Pass 2) - items changed since freight was quoted (was inside the admin freight panel, so a rep
     never saw it). Same comparison: the vendor-by-vendor item snapshot taken when freight was requested / applied. */
  Q.alertProviders.push(function itemsChangedAlert(st) {
    /* CUSTOM_ITEMSCHANGEDREQUEST_BY_CLAUDE (Ryan 2026-10-25, RW-1490-A/-B) - says WHAT moved, says when the price on screen was
       copied from another version, and Re-request opens the same drop-down as Fees & Extras (it used to fire the request
       straight away, for this version only, with no chance to see the delivery options or tick the other versions). */
    var ch = freightItemsChange();
    if (!ch) return null;
    return { id: 'items-changed', level: 'yellow', icon: '&#x1F4E6;', head: 'Items changed since freight was quoted', sig: ch.sig,
      text: ch.parts.join('; ') + '. ' + (ch.copied ? 'The freight price shown was copied from another version and does not cover these items. ' : '') + 'Freight needs a new quote.',
      action: { label: 'Re-request', run: function () { openRequestDropdown(); } },
      /* CUSTOM_FREIGHTFITS_BY_CLAUDE - admins: the freight still covers these items; saves straight away */
      action2: isAdmin ? { label: 'Freight still fits', run: function () {
        if (!confirmFreightFits(ch)) return;
        var saveBtn = wrap.querySelector('.rq-ws-send__save');
        if (saveBtn && Q.saveDraft) Q.saveDraft(saveBtn);
        updateRequestButton();
        renderAlerts();
        showToast('Freight kept: the items now on the quote are what this freight covers. A note goes on the deal feed.', 'success');
      } } : null };
  });

  // Exports
  Q.showAlert = showAlert;
  Q.hideAlert = hideAlert;
  Q.clearQuoteAlerts = clearQuoteAlerts;
  Q.renderAlerts = renderAlerts;
  Q.requestFreightNow = requestFreightNow;
  Q.openRequestDropdown = openRequestDropdown;
  Q.updateFeeDropdownOptions = updateFeeDropdownOptions;
  Q.updateRequestButton = updateRequestButton;
  Q.updateQuoteAge = updateQuoteAge;
  Q.openBulkModal = openBulkModal;
  Q.bulkBtn = bulkBtn;
  Q.bulkDrop = bulkDrop;
})();
